// styles.js
import styled from "@emotion/styled";

export const StyledComments = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .comments-loading {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }

  .comments-list {
    max-height: calc(100dvh - 230px);
    overflow-y: auto;
    padding-right: 4px;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #d9d9d9;
      border-radius: 4px;
    }
  }

  .comment-item {
    padding: 16px 0 !important;
    border-block-end: none !important;

    &:not(:last-child) {
      border-bottom: 1px solid #f0f0f0 !important;
    }
  }

  .comment-wrapper {
    display: flex;
    gap: 10px;
    width: 100%;
  }

  .comment-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .comment-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: -5px;
  }

  .comment-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .comment-author {
    font-size: 14px;
    color: #1f1f1f;
  }

  .comment-date {
    font-size: 11px;
    color: #8c8c8c;
  }

  .comment-content {
    font-size: 13px;
    color: #434343;
    word-break: break-word;
    white-space: pre-wrap;
    display: block;
    margin-bottom: 5px;
    .mention-user-name {
      color: var(--primary);
      font-weight: 500;
      cursor: pointer;
    }
  }

  .comment-edit-area {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
  }

  .comment-edit-input {
    font-size: 13px;
  }

  .comment-edit-actions {
    display: flex;
    justify-content: end;
    gap: 6px;
  }

  .comment-new {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 12px;
  }

  .comment-new-input {
    font-size: 13px;
  }

  .comment-submit-btn {
    margin-bottom: 0px;
    display: flex;
    justify-content: end;
  }

  .comment-footer {
    display: flex;
    gap: 10px;

    .message-reactions-div {
      display: flex !important;
      align-items: center;
      .reaction-button {
        padding: 0px;
        width: 16px;
        height: 16px;
      }
    }
    .reactions-bar {
      .reaction-bubble {
        padding: 2px 5px;
        background: #f0f2f5;
        border-radius: 5px;
        cursor: pointer;
        max-width: fit-content;
      }

      .reaction-emoji {
        font-size: 14px;
        line-height: 1;
        padding: 0px 2px;
      }

      .reaction-count {
        padding-left: 3px;
        font-size: 14px;
        color: #667781;
        font-weight: 500;
      }
    }
  }
`;
